<template>
<div class="chapter">
<div class="inner_page">
<p class="h2c"><a id="page_vi"></a>Contents</p>
<p class="toca" id="c01"><a href="#/xhtml/Preface#ch01">Preface</a></p>
<p class="toca" id="c02"><a href="#/xhtml/Acknowledgments#ch02">Acknowledgments</a></p>
<p class="toc" id="c03"><a href="#/xhtml/Part01#ch03"><b>1<br/>An Alternative Theory of Urban Politics</b></a></p>
<p class="toc2" id="c04"><a href="#/xhtml/Chapter01#ch04">1 City Limits and the Study of Urban Politics</a></p>
<p class="toc2" id="c05"><a href="#/xhtml/Chapter02#ch05">2 The Interests of the Limited City</a></p>
<p class="toc" id="c06"><span href="#/xhtml/Part02#ch06" title="Link target outside of Sample"><b>2<br/>City Limits and Public Policy</b></span></p>
<p class="toc2" id="c07"><span href="#/xhtml/Chapter03#ch07" title="Link target outside of Sample">3 The Three Policy Arenas</span></p>
<p class="toc2" id="c08"><span href="#/xhtml/Chapter04#ch08" title="Link target outside of Sample">4 Toward a New Theory of Federalism</span></p>
<p class="toc2" id="c09"><span href="#/xhtml/Chapter05#ch09" title="Link target outside of Sample">5 Cities, Suburbs, and Their Schools</span></p>
<p class="toc" id="c010"><a id="page_vii"></a><span href="#/xhtml/Part03#ch010" title="Link target outside of Sample"><b>3<br/>City Limits and Urban Politics</b></span></p>
<p class="toc2" id="c011"><span href="#/xhtml/Chapter06#ch011" title="Link target outside of Sample">6 Parties and Groups in Local Politics</span></p>
<p class="toc2" id="c012"><span href="#/xhtml/Chapter07#ch012" title="Link target outside of Sample">7 The Politics of Development</span></p>
<p class="toc2" id="c013"><span href="#/xhtml/Chapter08#ch013" title="Link target outside of Sample">8 The Politics of Allocation</span></p>
<p class="toc2" id="c014"><span href="#/xhtml/Chapter09#ch014" title="Link target outside of Sample">9 The Politics of Redistribution</span></p>
<p class="toc" id="c015"><span href="#/xhtml/Part04#ch015" title="Link target outside of Sample"><b>4<br/>Changing the Limits on Urban Policy</b></span></p>
<p class="toc2" id="c016"><span href="#/xhtml/Chapter10#ch016" title="Link target outside of Sample">10 Is New York a Deviant Case?</span></p>
<p class="toc2" id="c017"><span href="#/xhtml/Chapter11#ch017" title="Link target outside of Sample">11 Redistribution in the Federal System</span></p>
<p class="toca1" id="c018"><span href="#/xhtml/Appendix#ch018" title="Link target outside of Sample">Appendix<br/>Determinants of Local Expenditures, a Review of the Literature</span></p>
<p class="toca" id="c019"><span href="#/xhtml/Notes#ch019" title="Link target outside of Sample">Notes</span></p>
<p class="toca" id="c020"><span href="#/xhtml/References#ch020" title="Link target outside of Sample">References</span></p>
<p class="toca" id="c021"><span href="#/xhtml/Index#ch021" title="Link target outside of Sample">Index</span><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?53561095